'use client';

import React from 'react';
import debounce from 'lodash/debounce';

import { Input } from '../ui/input';

import useTranslation from '@/hooks/useTranslation';
import { cn } from '@/lib/utils';
import SearchIcon from '@/svgs/search.svg';

type SearchInputProps = {
  className?: string;
  debouncedValue: string;
  setDebouncedValue: React.Dispatch<React.SetStateAction<string>>;
};

const SearchInput: React.FC<SearchInputProps> = ({
  className,
  setDebouncedValue,
}) => {
  const { t } = useTranslation('components.searchInput');
  const [value, setValue] = React.useState('');

  const debounceFn = React.useCallback(debounce(setDebouncedValue, 500), []);

  const handleInputChange = (inputValue: string) => {
    setValue(inputValue);
    if (inputValue.trim().length >= 0) {
      debounceFn(inputValue);
    }
  };

  return (
    <div className={cn('relative', className)}>
      <Input
        className="h-11 bg-muted text-foreground text-sm pr-10.5 border-foreground focus-visible:ring-transparent rounded-lg"
        placeholder={`${t('placeholder')} ...`}
        value={value}
        onChange={(e) => handleInputChange(e.target.value)}
      />
      <div className="absolute top-3 right-3 w-[24px] h-[24px] flex items-center justify-center">
        <SearchIcon className="stroke-foreground" />
      </div>
    </div>
  );
};

export default SearchInput;
